import { render, staticRenderFns } from "./comp-dokumen.vue?vue&type=template&id=87fce214&scoped=true&"
import script from "./comp-dokumen.vue?vue&type=script&lang=js&"
export * from "./comp-dokumen.vue?vue&type=script&lang=js&"
import style0 from "./comp-dokumen.vue?vue&type=style&index=0&id=87fce214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fce214",
  null
  
)

export default component.exports